<!--
Author: TangChen
Date: 2018-09-25
Desc: 修改密码页面组件
 -->
<template>
    <div class="comp-change-num comp">
        <div class="change-pwd-title">
            <span class="tips-tit">{{ titTips.tit }}</span>
            <span class="tips-text">{{ titTips.text }}</span>
        </div>
        <div v-if="!resultFlag">
            <div class="con">
                <set-pwd :pwd-con="pwdSet" :is-reset="false" v-on:pwd-get="pwdOk" />
            </div>
        </div>

        <div v-else class="change-pwd-result">
            <div class="result-contain">
                <div class="result-img-contain">
                    <img src="../../assets/img/success.png" alt="" />
                </div>
                <div class="result-text">您好，{{ pwdSet.text }}密码已修改成功!</div>
                <div class="res-text">
                    {{ titTips.resText }}
                </div>
            </div>
            <div class="result-confirm-contain">
                <button class="result-confirm" v-on:click="checkDialogClose">确定</button>
            </div>
        </div>
    </div>
</template>
<script>
import setPwd from "@/components/layout/setPwdDc.vue";
import userApi from "@/api/user";

export default {
    name: "ChangeNum",
    components: {
        setPwd
    },
    props: {
        way: {
            type: String,
            default: "trade"
        },
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            resultFlag: false,
            pwdSet: {
                oldpwd: true,
                btn1: "确认修改",
                btn2: "取消",
                text: "登录",
                btnLock: false
            },
            titTips: {
                tit: "修改登录密码",
                text: "登录密码可用于快速登录网站/网上交易/APP/微信",
                resText: "该密码用于登录系统",
                cla: "login-pwd"
            },
            isTrade: false
        };
    },
    created() {
        this.isTrade = this.way === "trade";
        if (this.isTrade) {
            this.pwdSet.text = "交易";
            this.titTips = {
                tit: "修改交易密码",
                text: "交易密码用于下单等关键交易操作的安全验证",
                resText: "该密码用于基金的认购/申购、定投等交易行为",
                cla: "trade-pwd"
            };
        } else {
            const passwordType = this.$cache.getCompanyInfoParam("10109008");
            if (passwordType !== "1") {
                this.pwdSet.text = "登录/交易";
                this.titTips = {
                    tit: "修改登录/交易密码",
                    text: "登录/交易密码可用于快速登录网站/网上交易/APP/微信",
                    resText: "该密码用于登录系统及基金交易操作",
                    cla: "login-pwd"
                };
            }
        }
    },
    methods: {
        /* 提交表单数据 */
        pwdOk(action, val) {
            if (!action) {
                this.$router.back();
            } else {
                this.changePwd(val);
            }
        },
        async checkDialogClose() {
            this.$message.closeAll();
            if (this.isTrade) {
                this.$router.replace("/home");
            } else {
                this.$store.dispatch("logout", "").then(() => {
                    this.$router.replace("/");
                });
            }
        },
        // 修改密码
        async changePwd(val) {
            /* if (!this.isTrade && this.$cache.getUser().usertype === "2") {
                url = "acct/modpwd/cc";
            } */
            // if (this.way === "query") {
            //     url = "acct/modpwd/cc";
            // }
            // 修改登录密码
            if (!this.isTrade || this.way === "query") {
                const res = await userApi.updateLoginPwd({
                    opertype: "0",
                    oldpwd: this.$util.enc(val.old),
                    newpwd: this.$util.enc(val.pwd)
                });
                if (res.code == "0") {
                    this.resultFlag = true;
                    userApi.logout();
                    this.$handleAutoCloseMessage({
                        type: "success",
                        message1: "登录密码修改成功，",
                        message2: "秒后将回到登录页重新登录",
                        number: 3,
                        onClose: async () => {
                            this.$store.dispatch("logout", res.data).then(() => {
                                this.$router.replace("/");
                            });
                        }
                    });
                }
            } else {
                // 修改交易密码
                this.$confirm("确定修改交易密码吗？", "修改交易密码", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: ""
                }).then(() => {
                    userApi
                        .changeTradePwd({
                            oldpwd: this.$util.enc(val.old),
                            newpwd: this.$util.enc(val.pwd)
                        })
                        .then((res) => {
                            if (res.code === "0") {
                                this.$cache.refresh("_user").then((res) => {
                                    const userOtherInfo = this.$cache.getUserOtherInfo();
                                    if (userOtherInfo.specialflag == "3") {
                                        userOtherInfo.specialflag = res.specialflag;
                                        this.$cache.setUserOtherInfo(userOtherInfo);
                                        this.resultFlag = true;
                                        this.$handleAutoCloseMessage({
                                            type: "success",
                                            message1: "交易密码修改成功，",
                                            message2: "秒后将回到修改登录密码界面",
                                            number: 3,
                                            onClose: () => {
                                                this.$router.push({ name: "changelpwd" });
                                            }
                                        });
                                    } else {
                                        userOtherInfo.specialflag = res.specialflag;
                                        this.$cache.setUserOtherInfo(userOtherInfo);
                                        this.resultFlag = true;
                                        this.$handleAutoCloseMessage({
                                            type: "success",
                                            message1: "交易密码修改成功，",
                                            message2: "秒后将回到首页",
                                            number: 3,
                                            onClose: () => {
                                                this.$router.replace("/home");
                                            }
                                        });
                                    }
                                });
                            }
                        });
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.comp-change-num {
    padding-bottom: 40px;
    .change-pwd-title {
        height: 60px;
        line-height: 60px;
        background: #ffffff;
        margin: 0 20px;
        border-bottom: 1px solid #f1f1f1;
        .tips-tit {
            font-size: 20px;
            font-weight: 500;
            color: #333333;
        }
        .tips-text {
            margin-left: 8px;
            font-size: 16px;
            font-weight: normal;
            color: #999999;
        }
    }
    .con {
        margin-top: 20px;
    }
    .result-contain {
        width: 60%;
        width: 660px;
        height: 242px;
        border-radius: 6px;
        background: #f9f9f9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: auto;
    }
    .change-pwd-result {
        text-align: center;
        margin-top: 40px;
        .result-text {
            font-size: 26px;
            margin-top: 24px;
            font-weight: 500;
            color: #333333;
        }
        .res-text {
            font-size: 18px;
            margin-top: 14px;
            font-weight: normal;
            color: #666666;
        }
    }
    .result-confirm-contain {
        text-align: center;
        margin-top: 30px;
        .result-confirm {
            cursor: pointer;
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: var(--color-primary);
            border: 1px solid var(--color-primary);
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
        }
    }
}
</style>
